import { ModelBase } from 'store/model-base';

export class StatementV2Pdf extends ModelBase {
    public static storeName: string = 'statementV2Pdf';
    public pdf_url: string;
}
